import * as styleConstants from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import Typography from "@insite/mobius/Typography";
import React from "react";
import styled, { css } from "styled-components";

interface Props {
    text1: string;
    text2: string;
    onClick?: () => unknown;
}

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
    align-items: flex-start;
    @media (min-width: ${breakpointWidth("md")}) {
        width: 100%;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
    }
`;

const Wrapper = styled.li`
    display: flex;
    flex-flow: row nowrap;
    @media (min-width: ${breakpointWidth("md")}) {
        align-items: center;
    }
`;

const Text = styled.span`
    font-weight: 300;
    font-size: ${rem(15)};
    line-height: 1.5em;
    color: ${styleConstants.colours.black};
    @media (min-width: ${breakpointWidth("lg")}) {
        font-size: ${rem(18)};
    }
`;

const Button = styled(Clickable)`
    font-weight: 600;
    text-decoration: underline;
    font-size: ${rem(16)};
    line-height: 1em;
    padding: ${rem(9)} ${rem(12)};
    border: 1px solid ${styleConstants.colours.darkBlue};
    border-radius: 100px;
    color: ${styleConstants.colours.darkBlue};
    &:hover {
        color: ${styleConstants.colours.white};
        background-color: ${styleConstants.colours.darkBlue};
    }
`;

const IconWrapper = styled.div`
    flex-shrink: 0;
    width: ${rem(22)};
    height: ${rem(22)};
    border-radius: 50%;
    background-color: ${styleConstants.colours.green};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 ${rem(8)} 0 0;
    span {
        width: ${rem(10)};
        height: ${rem(10)};
        color: ${styleConstants.colours.white};
        svg {
            stroke-width: 4;
        }
    }
    @media (min-width: ${breakpointWidth("lg")}) {
        width: ${rem(26)};
        height: ${rem(26)};
        span {
            width: ${rem(14)};
            height: ${rem(14)};
        }
    }
`;

const OrderStepComplete = ({ text1, text2, onClick }: Props) => {
    return (
        <Wrapper>
            <IconWrapper>
                <Icon src={Check} title={undefined} />
            </IconWrapper>
            <TextWrapper>
                <Text>
                    {text1}
                    <strong>{text2}</strong>
                </Text>
                {onClick && <Button onClick={onClick}>Change</Button>}
            </TextWrapper>
        </Wrapper>
    );
};

export default OrderStepComplete;
